// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"87":"88a514b3","367":"a41495a5","634":"fc6f2805","787":"58984210"}[chunkId] + ".js";
};